import {ScheduledTransfer, ScheduledTransferStatus} from "@irati/types"
import {getScheduledTransfers} from "../../graph/scheduledTransfer"
import DateGroupedScheduledTransfers from "../../types/DateGroupedScheduledTransfers"

export const LIST_SCHEDULED_TRANSFERS = "LIST_SCHEDULED_TRANSFERS"
export const CLEAR_SCHEDULED_TRANSFERS = "CLEAR_SCHEDULED_TRANSFERS"

export interface ListAction {
  type: typeof LIST_SCHEDULED_TRANSFERS
  existingScheduledTransfers: DateGroupedScheduledTransfers[]
  newScheduledTransfers: ScheduledTransfer[]
  newCursor: string
}

export interface ClearAction {
  type: typeof CLEAR_SCHEDULED_TRANSFERS
}

export type ActionTypes = ListAction | ClearAction

const list = (
  existingScheduledTransfers: DateGroupedScheduledTransfers[],
  newScheduledTransfers: ScheduledTransfer[],
  newCursor: string
): ListAction => {
  return {
    type: LIST_SCHEDULED_TRANSFERS,
    existingScheduledTransfers,
    newScheduledTransfers,
    newCursor
  }
}

const clear = (): ClearAction => {
  return {
    type: CLEAR_SCHEDULED_TRANSFERS
  }
}

export const listScheduledTransfers = (
  existingScheduledTransfers: DateGroupedScheduledTransfers[],
  walletOwnerId: string,
  walletId: string,
  scheduledTransferStatusParam: ScheduledTransferStatus[],
  cursor: string | null,
  limit: number
) => {
  return (dispatch: (action: any) => void) => {
    return getScheduledTransfers(walletOwnerId, walletId, scheduledTransferStatusParam, cursor, limit).then(
      ({results, cursor: newCursor}) => {
        return dispatch(list(existingScheduledTransfers, results, newCursor))
      }
    )
  }
}

export const clearScheduledTransfers = () => {
  return (dispatch: (action: any) => void) => dispatch(clear())
}

export default {
  list: listScheduledTransfers,
  clear: clearScheduledTransfers
}
